import { render, staticRenderFns } from "./DiagramG.vue?vue&type=template&id=532e6ef2&scoped=true&"
import script from "./DiagramG.vue?vue&type=script&lang=js&"
export * from "./DiagramG.vue?vue&type=script&lang=js&"
import style0 from "./DiagramG.vue?vue&type=style&index=0&id=532e6ef2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532e6ef2",
  null
  
)

export default component.exports